import { render, staticRenderFns } from "./AppBarExtAdmin.vue?vue&type=template&id=57d0458e"
import script from "./AppBarExtAdmin.vue?vue&type=script&lang=js"
export * from "./AppBarExtAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports